import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared-module/seguridad/services/auth.guard';
import { CupoPrendaEmpleadoComponent  } from './views/cupo-prenda-empleado/cupo-prenda-empleado.component';
import { ParametroInicialComponent } from './views/parametro-inicial/parametro-inicial.component';
import { PrendaComponent } from './views/prenda/prenda.component';
import { TallaGrupoPrendaComponent } from './views/talla-grupo-prenda/talla-grupo-prenda.component';
import { DotacionUniformeComponent } from "./views/dotacion-uniforme/dotacion-uniforme.component";
import { DataLdapComponent } from './views/data-ldap/data-ldap.component';
import { AplicacionComponent } from './views/baja_usuario/aplicacion/aplicacion.component';
import { AplicacionUsuarioComponent } from './views/baja_usuario/aplicacion-usuario/aplicacion-usuario.component';

const SpyralRoutes: Routes = [
    { path: 'uniforme/cupo_prenda_empleado', component: CupoPrendaEmpleadoComponent, canActivate: [AuthGuard]}, //ROLE_ADECCO_FABRIL
    { path: 'uniforme/parametro_incial', component: ParametroInicialComponent, canActivate: [AuthGuard]}, //ROLE_ADECCO_FABRIL
    { path: 'uniforme/prenda', component: PrendaComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'uniforme/talla_grupo_prenda', component: TallaGrupoPrendaComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'uniforme/dotacion_uniforme', component: DotacionUniformeComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_PROVEEDOR
    { path: 'uniforme/data_ldap', component: DataLdapComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'baja_user/aplicacion', component: AplicacionComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'baja_user/aplicacion_user', component: AplicacionUsuarioComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(SpyralRoutes)],
    exports: [RouterModule]
  })
  export class UniformeRouteModule {}